// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federrate/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federrateDE: PageEntry = {
  id: "post.federrate",
  locale: "de",
  slug: "federrate",
  seo: {
    title: "Glossar: Federrate einfach erklärt | Dietz GmbH",
    description: "Die Federrate, auch als Federkonstante bezeichnet, gibt an, wie stark eine Feder ist, also wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehnen oder zu komprimie",
  },
  type: "post",
  h1: "Glossar: Federrate einfach erklärt",
  intro: "Die Federrate, auch als Federkonstante bezeichnet, gibt an, wie stark eine Feder ist, also wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehnen oder zu komprimieren. Sie wird in Newton pro Meter (N/m) gemessen. Eine höhere Federrate bedeutet, dass die Feder steifer ist und mehr Kraft benötigt, um sie zu verformen. Die Federrate ist ein entscheidender Parameter bei der Auslegung von Feder-Systemen, da sie direkt mit der Federkraft und anderen mechanischen Eigenschaften zusammenhängt. Sie beeinflusst die dynamischen Eigenschaften von Feder-Systemen und ist daher in verschiedenen Ingenieurdisziplinen von großer Bedeutung.",
  blocks: [

  ],
};
